<form [formGroup]="form_group" *ngIf="view_type==1">
  <label *ngIf="label_block" class="m-0 html-label" [ngClass]="{'req':required}"
    [innerHtml]="label | HTMLFormatter"></label>

  <mat-form-field [title]="label ? (label | translate : 1) : ''" floatLabel="always" appearance="standard"
    [ngClass]="{'read-only':readonly_view}">
    <mat-label *ngIf="!label_block&&required&&label" class="req">
      <span [innerHtml]="label | HTMLFormatter"></span>
    </mat-label>
    <mat-label *ngIf="!label_block&&!required&&label&&label!=''">
      <span [innerHtml]="label | HTMLFormatter"></span>
    </mat-label>
    <span matPrefix class="prefix" *ngIf="prefix_label">{{prefix_label}}&nbsp;</span>
    <span matSuffix class="suffix" *ngIf="suffix_label">&nbsp;{{suffix_label}}</span>
    <textarea matInput [placeholder]="placeholder" [value]="value" type="text" [id]="id" [style]="style ? style : ''"
      [formControlName]="form_control" [minLength]="minLength" [readonly]="disabled ? true : false" [name]="random_id">
            </textarea>
    <mat-error *ngIf="form_group.get([form_control]).hasError('required');else maxlength">
      Field is mandatory
      <!-- <span [innerHTML]="label + ' is mandatory'"></span> -->
    </mat-error>
    <ng-template #maxlength>
      <mat-error *ngIf="form_group.get([form_control]).hasError('maxlength');else minlength">
        Maximum length ({{maxLength}}) has exceeded
      </mat-error>
    </ng-template>
    <ng-template #minlength>
      <mat-error *ngIf="form_group.get([form_control]).hasError('minlength');else maxvalue">
        Minimum length must be {{minLength}} digits
      </mat-error>
    </ng-template>
    <ng-template #maxvalue>
      <mat-error *ngIf="form_group.get([form_control]).hasError('max');else minvalue">
        Value must be lesser than {{maxValue}}
      </mat-error>
    </ng-template>
    <ng-template #minvalue>
      <mat-error *ngIf="form_group.get([form_control]).hasError('min')">
        Value must be greater than {{minValue}}
      </mat-error>
    </ng-template>
  </mat-form-field>
</form>
<div class="attachment-container" [ngStyle]="style" *ngIf="view_type==2">
  <ng-container *ngIf="true">
    <mat-form-field floatLabel="always" [ngClass]="{'no-label':hide_label}" class="tm-radio-group">
      <mat-label [innerHtml]="label | HTMLFormatter" [ngClass]="{'req':required}"></mat-label>
      <div class="input-group  hide-dropdown-arrow">
        <div class="form-control " *ngIf="result">
          <span class=' notes-container' (click)="openChat()"
            [title]="result.length ? result[result.length-1].notes :'No notes'">
            <ng-container *ngIf="label">
              {{label }} :
            </ng-container>

            {{result.length ? result[result.length-1].notes :'No notes'}}
          </span>
        </div>

        <!-- <ng-container *ngIf="result">
              <span class="form-control pointer" [title]="i[this.save_filename]" *ngFor="let i of result"
                (click)="fileInput.click()">{{i['fileName'] ||
                i[this.save_filename]}}</span>
            </ng-container> -->

        <!-- <input type="file" class="form-control" (click)="fileInput.click()" placeholder="Recipient's username"
              aria-label="Recipient's username" aria-describedby="basic-addon2"> -->
        <div class="input-group-append pointer ">
          <span (click)="openChat()" class="btn btn-sm js-btn-save">
            ({{result.length}})
            <!-- <i class="fa fa-comments-o mr-1"></i> -->
          </span>
        </div>
      </div>
      <input matInput class="d-none">
    </mat-form-field>
    <!-- <label class="tm-chat-label" [ngClass]="{'req':required}" [innerHtml]="label | HTMLFormatter"></label> -->

  </ng-container>
</div>
<div class="attachment-container" [ngStyle]="style" *ngIf="view_type==3">
  <ng-container *ngIf="true">
    <i class="fa fa-comments" aria-hidden="true" (click)="openChat()"></i>
  </ng-container>
</div>
